import { Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Footer from './Footer';

function LegalLayout({ title, effectiveDate, children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App legal-page">
      <header className="legal-header">
        <Container className="d-flex align-items-center justify-content-between py-3">
          <Link to="/" className="brand-text d-flex align-items-center legal-brand-link">
            <img src="/mintHubLogo.png" alt="MintHub - Professional websites for local businesses" className="brand-logo me-2" />
            <span><span className="brand-mint">Mint</span><span className="brand-hub">Hub</span></span>
          </Link>
          <Link to="/" className="legal-back-link">&larr; Back to Home</Link>
        </Container>
      </header>

      <Container className="legal-content py-5">
        <h1 className="section-title mb-2">{title}</h1>
        <p className="text-muted legal-effective-date">Effective date: {effectiveDate}</p>
        <div className="legal-body">
          {children}
        </div>
      </Container>

      <Footer />
    </div>
  );
}

export default LegalLayout;
